module.exports = __webpack_public_path__ + "img/ydsj2.222b8996.svg";